<template>
  <div class="doctor-detail-wrapper">
    <div class="background"></div>
    <div class="detail-main" v-if="doctorData">
      <div class="unbind"><a href="javascript:;" @click="unbindShow = true">解除绑定</a></div>
      <div class="doctor-wrapper">
        <div class="doctor-info">
          <div class="avatar"><img :src="doctorData.avatar" alt=""></div>
          <div class="info">
            <div class="name">{{doctorData.username}}<span>{{doctorData.title | jobTitleFilter}}</span></div>
            <div class="department">{{doctorData.p_dep_title}} | {{doctorData.dep_title}}</div>
          </div>
        </div>
        <div class="doctor-content">
          <div class="content-section">
            <div class="type">执业经历</div>
            <div class="content">
              <div class="text-content">{{doctorData.description}}</div>
            </div>
          </div>
          <div class="content-section" v-if="doctorData.adept">
            <div class="type">专业擅长</div>
            <div class="content">
              <div class="text-content">{{doctorData.adept}}</div>
            </div>
          </div>
          <div class="content-section" v-if="doctorData.offline_info">
            <div class="type">线下诊疗日程</div>
            <div class="content">
              <div class="schedule-list">
                <div class="schedule-day" v-for="item in doctorData.offline_info">
                  <div class="schedule-title">{{item.hospital}}/{{item.position}}</div>

                  <div class="offline-title">{{item.day}}<span>{{item.week}}</span> </div>
                  <div class="day-list">
                    <div class="schedule-item" v-for="schedule in item.schedule">
                      <div class="time">{{schedule.start_time | timeFilter}} - {{schedule.end_time | timeFilter}}</div>
                      <div class="control">
                        <span class="limit" v-if="schedule.enrollers >= schedule.pat_limit">已约满</span>
                       <!-- <span class="limit" v-else>剩余 {{getOffline==0?schedule.pat_limit -schedule.enrollers:getOffline}}</span>-->
                        <span class="limit" v-else>有余号 可预约</span>
                        <!-- enroll_status 0:未预约 234：已预约 5：已预约待支付 -->
                        <button class="order ordered" v-if="schedule.enroll_status != 5 && schedule.enroll_status != 0"
                          @click="offline(schedule)">已预约</button>
                        <button class="order" v-else :class="{'ordered': schedule.enroll_status != 5 && schedule.enroll_status != 0}"
                          @click="offline(schedule)" :disabled="schedule.enrollers >= schedule.pat_limit">{{schedule.enroll_status != 5 && schedule.enroll_status != 0 ? '已预约' : '立即预约'}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-section" v-if="doctorData.schedule_info">
            <div class="type">线上诊疗日程</div>
            <div class="content">
              <div class="schedule-list">
                <div class="schedule-day" v-for="item in doctorData.schedule_info">
                  <div class="schedule-title">{{item.day}}<span>{{item.week}}</span></div>
                  <div class="day-list">
                    <div class="schedule-item" v-for="schedule in item.schedule">
                      <div class="time">{{schedule.start_time | timeFilter}} - {{schedule.end_time | timeFilter}}</div>
                      <div class="control">
                        <span class="limit" v-if="schedule.enrollers >= schedule.pat_limit">已约满</span>
                        <span class="limit" v-else>{{schedule.enrollers}}/{{schedule.pat_limit}} 人</span>
                        <!-- enroll_status 0:未预约 234：已预约 5：已预约待支付 -->
                        <button class="order ordered" v-if="schedule.enroll_status != 5 && schedule.enroll_status != 0"
                          @click="order(schedule)">已预约</button>
                        <button class="order" v-else :class="{'ordered': schedule.enroll_status != 5 && schedule.enroll_status != 0}"
                          @click="order(schedule)" :disabled="schedule.enrollers >= schedule.pat_limit">{{schedule.enroll_status != 5 && schedule.enroll_status != 0 ? '已预约' : '立即预约'}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="live-inquiry" v-if="doctorData"><button class="live-button" @click="liveChat">
        <icon icon-class="live-chat"></icon>发起实时问诊
      </button></div>

    <!-- 解除绑定弹窗 -->
    <x-dialog v-if="unbindShow" title="解除绑定" @close="unbindShow = false">
      <div class="unbind-content">
        <div class="text">是否解除与<span>{{doctorData.username}}医生</span>的绑定</div>
        <div class="unbind-control">
          <button class="cancel" @click="unbindShow = false">取消</button>
          <button class="confirm" @click="unbindDoctor" :disabled="unbinding">确定</button>
        </div>
      </div>
    </x-dialog>
    <!-- 重复预约弹窗 -->
    <x-dialog v-if="repeatShow" title="重复预约" @close="repeatShow = false">
      <div class="repeat-content">
        <div class="text">七天内不可重复预约医生复诊<br>如有需要可<span @click="liveChat">发起实时问诊</span></div>
        <button class="repeat-button" @click="repeatShow = false">好的</button>
      </div>
    </x-dialog>
    <!-- 已有订单 -->
    <x-dialog v-if="hasOrderShow" title="预约失败" @close="hasOrderShow = false">
      <div class="has-order-content">
        <div class="text">您在相同的时间段还有尚未支付的预约</div>
        <div class="control">
          <button class="cancel" @click="hasOrderShow = false">取消</button>
          <button class="confirm" @click="toPayment">去支付</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .doctor-detail-wrapper{
    position: relative;
    min-height: 100vh;
    background: #F7F7F7;
    .background{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 184px;
      background: @linear;
      z-index: 1;
    }
    .detail-main{
      position: relative;
      padding: 20px 12px 96px;
      z-index: 10;
      .unbind{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
        a{
          color: #FFF;
          font-size: 14px;
          line-height: 14px;
          padding-right: 4px;
        }
      }
      .doctor-wrapper{
        padding: 30px 12px 0;
        background: #FFF;
        border-radius: 6px;
        box-shadow:0px 4px 10px 0px rgba(123,103,66,0.1);
        .doctor-info{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 8px;
          .avatar{
            width: 72px;
            height: 72px;
            overflow: hidden;
            border-radius: 50%;
            img{
              width: 100%;
            }
          }
          .info{
            margin-left: 16px;
            .name{
              font-size: 18px;
              line-height: 18px;
              color: @black;
              font-weight: bold;
              span{
                margin-left: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #999;
                font-weight: normal;
              }
            }
            .department{
              margin-top: 11px;
              font-size: 14px;
              line-height: 14px;
              color: #666;
            }
          }
        }
        .doctor-content{
          padding-top: 32px;
          padding-bottom: 27px;
          .content-section{
            margin-bottom: 36px;
            &:last-child{
              margin-bottom: 0;
            }
            .type{
              font-size: 16px;
              line-height: 16px;
              color: @black;
              font-weight: bold;
              padding: 0 8px;
            }
            .content{
              margin-top: 8px;
              .text-content{
                padding: 0 8px;
                font-size: 14px;
                line-height: 22px;
                color: @black;
                font-weight: normal;
                word-break: break-all;
              }
              .schedule-list{
                .schedule-day{
                  border-bottom: dashed 1px #DDDDDD;
                  margin-top: 15px;
                  margin-bottom: 5px;
                  .schedule-title{
                    width: 100%;
                    padding: 0 8px;
                    background: #F7F7F7;
                    height: 28px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 16px;
                    line-height: 16px;
                    color: @black;
                    font-weight: bold;
                    span{
                      margin-left: 12px;
                      border: 1px solid #CCC;
                      padding: 0 8px;
                      height: 18px;
                      font-size: 12px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      color: #999;
                      font-weight: bold;
                      border-radius: 18px;
                    }
                  }
                  .offline-title{
                    width: 100%;
                    padding: 0 8px;
                    background: #F7F7F7;
                    height: 28px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 15px;
                    line-height: 16px;
                    color:#707070;
                    font-weight: bold;
                    span{
                      margin-left: 12px;
                      border: 1px solid #CCC;
                      padding: 0 8px;
                      height: 18px;
                      font-size: 12px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      color: #999;
                      font-weight: bold;
                      border-radius: 18px;
                    }
                  }
                  .day-list{
                    padding-left: 8px;
                    .schedule-item{
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      height: 53px;
                      border-bottom: 1px solid #EEE;
                      &:last-child{
                        border-bottom: 0;
                      }
                      .time{
                        font-size: 16px;
                        line-height: 16px;
                        color: @black;
                      }
                      .control{
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        .limit{
                          font-size: 14px;
                          color: #666;
                          margin-right: 16px;
                        }
                        .order{
                          @button-base();
                          @button-border();
                          width: 68px;
                          height: 28px;
                          font-size: 12px;
                          font-weight: normal;
                          margin-right: 4px;
                          border-radius: 28px;
                          background: @xile;
                          color: #FFF;
                          &:disabled{
                            background: transparent;
                            border-color: #CCC;
                            color: #999;
                          }
                          &.ordered{
                            background: #FFF;
                            color: @xile;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .live-inquiry{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 14px 16px 10px;
      background: #FFF;
      z-index: 20;
      .live-button{
        @button-base();
        width: 100%;
        height: 40px;
        svg{
          font-size: 20px;
          margin-right: 4px;
        }
      }
    }
    .unbind-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        font-size: 16px;
        line-height: 16px;
        color: @black;
        font-weight: bold;
        span{
          margin: 0 6px;
          color: @xile;
        }
      }
      .unbind-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          width: 136px;
          height: 36px;
          &.cancel{
            @button-border();
            margin-right: 13px;
          }
        }
      }
    }
    .repeat-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        text-align: center;
        font-size: 14px;
        line-height: 22px;
        color: @black;
        span{
          color: @xile;
        }
      }
      .repeat-button{
        @button-base();
        margin-top: 40px;
        width: 240px;
        height: 36px;
      }
    }
    .has-order-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        text-align: center;
        font-size: 14px;
        line-height: 22px;
        color: @black;
        span{
          color: @xile;
        }
      }
      .control{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
        button{
          @button-base();
          width: 136px;
          height: 36px;
          &.cancel{
            @button-border();
            margin-right: 13px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        repeatShow: false,
        unbindShow: false,
        doctorData: null,
        unbinding: false,
        hasOrderShow: false,
        orderId: null,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      getOffline() {
        let doc_id = this.$route.params.id;
        if (parseInt(doc_id) == 10566) {
          return 1
        }
        if (parseInt(doc_id) == 10070) {
          return 2
        }
        if (parseInt(doc_id) == 10149) {
          return 3
        }
        return 0
      }
    },
    components: {
      xDialog
    },
    created() {
      this.$root.post('/getDoctorDetail', {
        pat_id: this.userInfo.user_id,
        doc_id: this.$route.params.id
      }).then(data => {
        console.log(data);
        this.doctorData = data || null;
      })
    },
    methods: {
      unbindDoctor() {
        this.unbinding = true;
        this.$root.post('/cancelDoctor', {
          id: this.doctorData.bind_id
        }).then(data => {
          console.log(data);
          this.unbinding = false;
          if (data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '解除绑定成功'
            });
            this.$router.go(-1);
          } else {
            this.$notify(data.msg);
          }
        })
      },
      offline(item) {
        console.log(item);
        if (item.enroll_status == 1) {
          this.$router.push({
            path: '/patient/order/offline',
            query: {
              schedule_id: item.schedule_id,
              doc_id: this.$route.params.id,
              type: 3,
              enroll: true
            }
          });
        }
        if (item && item.enroll_status == 0) {
          this.$root.post('/isAllowOffline', {
            pat_id: this.userInfo.user_id,
            doc_id: this.$route.params.id,
            schedule_id: item.schedule_id,
          }).then(data => {
            console.log(data);
            if (data.status == 1) {
              this.$router.push({
                path: '/patient/order/offline',
                query: {
                  schedule_id: item.schedule_id,
                  doc_id: this.$route.params.id,
                  type: 3
                }
              });
            } else if (data.status == 2) {
              // 已预约待支付
              this.repeatShow = true;
            } else if (data.enroll_status == 5) {
              console.log('待支付');
            } else {
              this.$notify(data.msg);
            }
          })
        } else if (item && item.enroll_status == 5) {
          this.orderId = item.order_id;
          this.hasOrderShow = true;
        } else {
          return;
        }
      },
      order(item) {
        console.log(item);
        if (item.enroll_status == 1) {
          this.$router.push({
            path: '/patient/order/payment',
            query: {
              schedule_id: item.schedule_id,
              doc_id: this.$route.params.id,
              type: 1,
              enroll: true
            }
          });
        }
        if (item && item.enroll_status == 0) {
          this.$root.post('/isAllowEnroll', {
            pat_id: this.userInfo.user_id,
            doc_id: this.$route.params.id,
            schedule_id: item.schedule_id,
          }).then(data => {
            console.log(data);
            if (data.status == 1) {
              this.$router.push({
                path: '/patient/order/payment',
                query: {
                  schedule_id: item.schedule_id,
                  doc_id: this.$route.params.id,
                  type: 1
                }
              });
            } else if (data.status == 2) {
              // 已预约待支付
              this.repeatShow = true;
            } else if (data.enroll_status == 5) {
              console.log('待支付');
            } else {
              this.$notify(data.msg);
            }
          })
        } else if (item && item.enroll_status == 5) {
          this.orderId = item.order_id;
          this.hasOrderShow = true;
        } else {
          return;
        }
      },
      liveChat() {
        this.$root.post('/isAllowEnroll', {
          pat_id: this.userInfo.user_id,
          doc_id: this.$route.params.id,
        }).then(data => {
          if (data.status == 1) {
            this.$router.push({
              path: '/patient/order/payment',
              query: {
                doc_id: this.$route.params.id,
                type: 2
              }
            });
          } else {
            this.$notify(data.msg);
          }
        })
      },
      toPayment() {
        this.$router.push({
          path: '/patient/order/detail',
          query: {
            order_id: this.orderId
          }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/MyDoctor/detail.vue